import { observable } from "mobx";
import { IAttachment } from "./chat/chatItems";
import { IEquals } from "./common";
import { getWheelhouseDownloadUrl } from "@fidget/common/utils/urlMappingHelpers";

export enum FileUploadState {
  NEW = "new",
  IN_PROGRESS = "inProgress",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
  SCAN_FAILED = "scan_failed",
  VIRUS_FOUND = "virus_found",
  TOO_BIG = "too_big",
  UNSUPPORTED_TYPE = "unsupported_type",
  MALFORMED_FILE_CONTENT = "malformed_file_content"
}

export const isUploadFailed = (state: FileUploadState): boolean => {
  return (
    state === FileUploadState.FAILED ||
    state === FileUploadState.SCAN_FAILED ||
    state === FileUploadState.TOO_BIG ||
    state === FileUploadState.VIRUS_FOUND ||
    state === FileUploadState.UNSUPPORTED_TYPE ||
    state === FileUploadState.MALFORMED_FILE_CONTENT
  );
};

export interface IFileUploadInfo extends IEquals<IFileUploadInfo> {
  readonly id: string;
  readonly file: File;
  readonly dataUrl?: string;
  attachment?: IAttachment;
  uploadState: FileUploadState;
  readonly isCompleted: boolean;
  readonly isNotReady: boolean;
  readonly roomId: string;
}

export class FileUploadInfo implements IFileUploadInfo {
  attachment?: IAttachment;
  @observable uploadState: FileUploadState;
  @observable private _dataUrl: string;
  readonly id: string;

  constructor(readonly file: File, readonly roomId: string) {
    this.id = `${file.name}:${file.size}`;
    this.uploadState = FileUploadState.NEW;
    this._dataUrl = "";
    this.readFile();
  }

  get dataUrl(): string {
    return this._dataUrl;
  }

  get isNotReady(): boolean {
    return (
      this.uploadState === FileUploadState.NEW || this.uploadState === FileUploadState.IN_PROGRESS
    );
  }

  get isCompleted(): boolean {
    return this.uploadState === FileUploadState.SUCCEEDED && !!this.attachment;
  }

  equals(other: IFileUploadInfo): boolean {
    return other && other.id === this.id;
  }

  private readFile() {
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this._dataUrl = event.target.result;
    };
    reader.readAsDataURL(this.file);
  }
}

export const uploadInfoFromIntentAttachment = (attachment: IAttachment): IFileUploadInfo => {
  const { fileName, size, contentType, id, token, roomId } = attachment;
  if (fileName !== undefined && size !== undefined && contentType && id) {
    const file = {
      size,
      name: fileName,
      type: contentType
    };

    return {
      id,
      roomId: roomId || "",
      attachment,
      file: file as File,
      dataUrl: getWheelhouseDownloadUrl(token),
      uploadState: FileUploadState.SUCCEEDED,
      isCompleted: true,
      isNotReady: false,
      equals(f: IFileUploadInfo) {
        return fileName === f.file.name && size === f.file.size;
      }
    };
  }

  throw new Error("Incorrect saved attachment");
};
